import * as THREE from 'three'
import Experience from './Experience.js'

export default class Content {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sizes = this.experience.sizes
        this.time = this.experience.time
        this.resources = this.experience.resources
        this.world = this.experience.world
        this.mouse = this.experience.mouse

        this.setGeometry()
        this.setTextures()
        this.setMaterial()
        this.setMesh()
        this.setAnimation()
    }

    setGeometry() {
        this.geometry = new THREE.PlaneGeometry(0.8, 0.8, 1, 1)
    }

    setTextures() {
        this.textures = {}
        this.textures.color = this.resources.items.triangleTexture
        this.textures.encoding = THREE.sRGBEncoding
    }

    setMaterial() {
        this.material = new THREE.MeshBasicMaterial({
            depthWrite: false,
            transparent: true,
            map: this.textures.color
        })
    }

    setMesh() {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.z = 0.1
        this.mesh.position.x = 0.4
        this.mesh.position.y = 0.5
        this.mesh.rotation.z = 0.2
        this.scene.add(this.mesh)
    }

    setAnimation() {
        window.addEventListener('scroll', () => {
            this.mouse.scroll = window.scrollY
            this.mesh.position.z = -0.15 -this.mouse.scroll / this.sizes.height * 4
            this.mesh.material.opacity = 1 - this.mouse.scroll / this.sizes.height * 2.5
        })
    }

    update() {
        this.mesh.position.y = 0.5 + Math.sin(this.time.elapsed * 0.0008) * 0.01
    }

}